import * as zod from 'zod';

import { six } from '@sb/utilities';

// A set of arm joint velocities in radians per second, in order from joint 0 to joint 5.
export const ArmJointVelocities = zod.tuple([
  zod.number(),
  zod.number(),
  zod.number(),
  zod.number(),
  zod.number(),
  zod.number(),
]);

export type ArmJointVelocities = zod.infer<typeof ArmJointVelocities>;

// radians / second
export const ABSOLUTE_MAX_JOINT_SPEEDS: ArmJointVelocities = [
  4.7, 4.7, 5, 6.8, 6.8, 6.8,
];

export const COLLABORATIVE_MAX_JOINT_SPEEDS: ArmJointVelocities = [
  1.8, 1.8, 2.5, 3.4, 3.4, 2.0,
];

export const DEFAULT_MAX_JOINT_SPEEDS = COLLABORATIVE_MAX_JOINT_SPEEDS;

export const THOR_MAX_JOINT_SPEEDS: ArmJointVelocities = [
  1.75, 1.75, 2.15, 2.9, 2.9, 2.9,
];

export const THOR_BETA_RESTRICTION_JOINT_SPEEDS: ArmJointVelocities = [
  0.9, 0.9, 1.25, 1.55, 1.55, 1.55,
];

export const ANTIGRAVITY_SPEEDS_DEFAULT: ArmJointVelocities = six(0.3);

// meters / second
export const ABSOLUTE_MAX_TOOLTIP_SPEED = 5;
export const COLLABORATIVE_MAX_TOOLTIP_SPEED = 1.25;
export const DEFAULT_MAX_TOOLTIP_SPEED = COLLABORATIVE_MAX_TOOLTIP_SPEED;

// meters / second squared
export const DEFAULT_MAX_TOOLTIP_ACCELERATION = null; // Safety limit
export const DEFAULT_WELD_TOOLTIP_ACCELERATION = 0.05; // 50 mm/s^2
export const MAX_WELD_TOOLTIP_ACCELERATION = 0.4; // 400 mm/s^2

export const TESTRUN_MAX_JOINT_SPEEDS: ArmJointVelocities = six(0.25);
